import React, { useContext, useState, useEffect } from 'react';
import CurtainMonitor from './CurtainMonitor';
import CurtainNotification from './CurtainNotification';
import useCurtainNotifications from '../../../hooks/useCurtainNotifications';
import { UserContext } from '../../../context/UserProvider';
import { db } from '../../../config/firebase';

/**
 * Componente global que integra el monitoreo de cortinas y las notificaciones
 * Este componente debe ser montado a nivel de aplicación para funcionar globalmente
 */
const CurtainGlobalMonitor = () => {
  const { usuario } = useContext(UserContext);
  const [curtainsData, setCurtainsData] = useState([]);

  const {
    currentNotification,
    notifyCurtainOperation,
    hideCurrentNotification,
    hasCurrentNotification
  } = useCurtainNotifications();

  // Cargar datos de cortinas desde Firebase
  useEffect(() => {
    const fetchCurtainsData = async () => {
      if (usuario && usuario.username) {
        try {
          const docRef = db.collection(usuario.username).doc("curtainControl");
          const docSnapshot = await docRef.get();
          if (docSnapshot.exists) {
            const data = docSnapshot.data();
            const registeredCurtains = data.registeredCurtains || [];
            setCurtainsData(registeredCurtains);
          }
        } catch (error) {
          console.error(`[CurtainGlobalMonitor] Error al obtener los datos de las cortinas: ${error}`);
        }
      }
    };
    fetchCurtainsData();
  }, [usuario]);

  // Listener para eventos de inicio de operación desde ManualCurtainControl
  useEffect(() => {
    const handleCurtainOperationStart = (event) => {
      // El monitor ya maneja esto internamente, pero podemos agregar lógica adicional aquí si es necesario
      console.log('[CurtainGlobalMonitor] Evento de inicio de operación recibido:', event.detail);
    };

    window.addEventListener('curtainOperationStart', handleCurtainOperationStart);

    return () => {
      window.removeEventListener('curtainOperationStart', handleCurtainOperationStart);
    };
  }, []);

  // Listener para eventos de finalización de operación
  useEffect(() => {
    const handleCurtainOperationComplete = (event) => {
      // El monitor ya maneja las notificaciones, pero podemos agregar lógica adicional aquí si es necesario
      console.log('[CurtainGlobalMonitor] Evento de finalización de operación recibido:', event.detail);
    };

    window.addEventListener('curtainOperationComplete', handleCurtainOperationComplete);

    return () => {
      window.removeEventListener('curtainOperationComplete', handleCurtainOperationComplete);
    };
  }, []);

  // Función para manejar notificaciones del monitor
  const handleMonitorNotification = (notificationData) => {
    notifyCurtainOperation(notificationData);
  };

  // Función para cerrar la notificación actual
  const handleCloseNotification = () => {
    hideCurrentNotification();
  };

  // Solo renderizar si hay un usuario autenticado
  if (!usuario || !usuario.username) {
    return null;
  }

  return (
    <>
      {/* Monitor de cortinas - funciona en segundo plano */}
      <CurtainMonitor 
        onNotification={handleMonitorNotification} 
        curtainsData={curtainsData}
      />

      {/* Componente de notificación visual */}
      <CurtainNotification
        notification={currentNotification}
        open={hasCurrentNotification}
        onClose={handleCloseNotification}
        autoHideDuration={6000}
      />
    </>
  );
};

export default CurtainGlobalMonitor;

